import { dialog } from "../../../nq-component";
import BaseListPresenter from "../../../base/BaseListPresenter";
import saveAs from "../../../saveAs";
import QRCode from "qrcode";
import {
  deleteObjectUseCase,
  updateObjectUseCase,
} from "../../../usecases/object";
import { getCurrentUserUseCase } from "../../../usecases/user";

import {
  base64ToBlob,
  formatDate,
  formatDateUTC,
  formatTimeUTC,
  generateEmailBody,
} from "./utils/utils";
import { restUseCase } from "../../../usecases/rest";
import { saveImageUseCase } from "../../../usecases/file";

class ApplicantBoardingListPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase,
    getObjectUseCase,
  ) {
    super(
      view,
      findObjectUseCase,
      countObjectUseCase,
      deleteObjectUseCase,
      getObjectUseCase,
    );
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
    this.getObjectUseCase = getObjectUseCase;
  }

  componentDidMount() {
    const token = this.view.getToken();
    console.log("token", token);
    this.init();
    this.getUser(token);
    return this.getObjects();
  }

  init() {
    this.limit = 20;
    this.where = {};
    this.search = {};
    this.filter = {};
    this.include = ["all"];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }

  dateQuery(date) {
    const assignedDate = new Date(date); // Convert to Date object
    const startOfDay = new Date(
      Date.UTC(
        assignedDate.getUTCFullYear(),
        assignedDate.getUTCMonth(),
        assignedDate.getUTCDate(),
        0,
        0,
        0,
        1,
      ),
    ).toISOString();
    const endOfDay = new Date(
      Date.UTC(
        assignedDate.getUTCFullYear(),
        assignedDate.getUTCMonth(),
        assignedDate.getUTCDate(),
        23,
        59,
        59,
        999,
      ),
    ).toISOString();

    return { startOfDay, endOfDay };
  }

  async findObjects() {
    const params = this.view.getParams();
    try {
      this.showProgress();
      this.findObjectUseCase.abort();

      const object = await this.getObjectUseCase.execute(
        "on_boarding",
        params.id,
      );

      const { onBoardStartTime, onBoardEndTime } = object;
      const query = {
        where: {
          onBoardStartTime: {
            $gte: onBoardStartTime,
          },
          onBoardEndTime: {
            $lte: onBoardEndTime,
          },
          // status: "On-boarding",
        },
        include: ["all", "users", "applicant.users"],
      };

      const [online, walkIn, reprocess] = await Promise.all([
        this.findObjectUseCase.execute("online_applicants", query),
        this.findObjectUseCase.execute("walkIn_applicants", query),
        this.findObjectUseCase.execute("reprocess_applicants", query),
      ]);

      console.log("online", online);
      console.log("walkIn", walkIn);
      console.log("reprocess", reprocess);

      this.objects = [...online, ...walkIn, ...reprocess];

      console.log("query", query);
      console.log("On Board Applicants", this.objects);
      this.view.setTotal(this.objects.length);
      this.view.setTitle(this.objects);
      this.view.setObjects(this.objects);

      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    } finally {
      this.progress = false;
    }
  }

  onClickAdd() {
    const collection = this.view.getCollectionName();
    this.view.navigateTo("/admin/employee/form");
  }

  async onClickEdit(empDetails) {
    const collection = this.view.getCollectionName();
    const query = {
      where: { id: empDetails.id },
      include: ["employee", "location"],
    };
    const response = await this.findObjectUseCase.execute(collection, query);

    if (response && response.length > 0) {
      const object = response[0];

      this.view.setState(
        {
          formData: {
            id: object?.id,
            employee: object?.employee || {},
            username: object?.username || "",
            password: "",
            roles: object?.roles?.[0] || {},
            location: object?.location || {},
            clients: object?.clients || [],
          },
          showModal: true,
        },
        // () => {
        //   this.view.onClickAdd(object);
        // }
      );
    }
  }

  async onClickDelete(empDetails) {
    dialog.close();
    const object = empDetails;
    const collection = this.view.getCollectionName();

    await deleteObjectUseCase().execute(collection, object.id);
    this.view.setObjects(this.objects);
    this.reset();
    this.getObjects();
  }
  showImage() {
    dialog.fire({
      html: (
        <>
          <div className="d-flex justify-content-center mt-2">
            <img
              src="/emailLoading2.gif"
              alt="loading"
              style={{ width: "200px", height: "200px" }}
            />
          </div>
          <div className="text-center mt-3">
            <p style={{ color: "#D18237" }}>Sending email... Please wait...</p>
          </div>
        </>
      ),
      footer: false,
    });
  }

  async sendEmail(qrData, blobToImgApi, getUserEmployee, getApplicantEmail) {
    const match = qrData.match(
      /^(.*?)\s*-\s*(.*?)\s*-\s*(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z)\s*-\s*(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z)$/,
    );

    if (!match) {
      console.error("Invalid QR Data format");
      return;
    }

    const [_, firstName, lastName, startDateTimeStr, endDateTimeStr] = match;
    const newStartDateTime = new Date(startDateTimeStr);
    const newEndDateTime = new Date(endDateTimeStr);

    const formattedDateUTC = formatDateUTC(newStartDateTime);
    const formattedStartTimeUTC = formatTimeUTC(newStartDateTime);
    const formattedEndTimeUTC = formatTimeUTC(newEndDateTime);

    const method = "POST";
    const path = "/send-email/d16bcf82-2a04-4eb0-bff8-139d65a4ae56";

    const obj = {
      to: getApplicantEmail,
      subject: "EMAIL INVITATION FOR AN INTERVIEW",
      body: generateEmailBody(
        lastName,
        formattedDateUTC,
        formattedStartTimeUTC,
        formattedEndTimeUTC,
        blobToImgApi,
        getUserEmployee,
      ),
    };

    try {
      this.showImage();
      const response = await restUseCase().execute(method, path, { body: obj });

      if (response) {
        dialog.close();
        this.view.setObjects(this.objects);
        this.view.successModal(response.message);
      }
    } catch (error) {
      console.error("Error sending email:", error);
    }
  }

  async generateQRCode(data) {
    try {
      return await QRCode.toDataURL(data);
    } catch (err) {
      console.error("Error generating QR Code", err);
      return null;
    }
  }

  async getUserEmployee(id) {
    const collection = "employees";
    const query = {
      where: {
        id: id,
      },
    };
    const response = await this.findObjectUseCase.execute(collection, query);
    return response[0];
  }

  async getApplicantsEmail(id) {
    if (!id) return;
    try {
      this.view.showProgress();
      const object = await this.getObjectUseCase.execute("users", id);
      return object?.email;
    } catch (error) {
      this.view.showError(error);
    } finally {
      this.view.hideProgress();
    }
  }

  async handleClickHireApplicant(
    object,
    startDateTime,
    endDateTime,
    employmentStatus,
  ) {
    if (!object?.id) return;

    const applicationType = object?.interviewCoordinator;
    const collection = {
      online: "online_applicants",
      walkIn: "walkIn_applicants",
      reprocess: "reprocess_applicants",
    }[applicationType];

    try {
      const user = this.view.getCurrentUser();
      const getUserEmployee = await this.getUserEmployee(user.employee.id);
      const getApplicantEmail = await this.getApplicantsEmail(
        object?.applicant?.id,
      );

      Object.assign(object, {
        hireStartDate: startDateTime,
        hireEndDate: endDateTime,
        employmentStatus,
        status: "On-boarding",
        applicant: { id: object.applicant.id },
        coordinator: { id: object.coordinator.id },
        recruiter: { id: object.recruiter.id },
      });

      const updatedObject = {
        ...object,
        status: "Active",
        position: object.positionApplied,
        mobileNumber: object.present_telephone,
      };
      const [data, employee] = await Promise.all([
        this.upsertUseCase.execute(collection, object),
        this.upsertUseCase.execute("employees", updatedObject),
      ]);

      if (!data || typeof data !== "object") {
        console.warn("Invalid response data");
        return;
      }

      const qrData = `${data.firstName}-${data.lastName}-${data.hireStartDate}-${data.hireEndDate}`;
      const qrCode = await this.generateQRCode(qrData);

      if (!qrCode?.startsWith("data:image/")) {
        console.error("Invalid QR Code format");
        return;
      }

      const blobToImgApi = await saveImageUseCase().execute(
        new File([base64ToBlob(qrCode, "image/png")], "image.png", {
          type: "image/png",
        }),
      );

      this.sendEmail(qrData, blobToImgApi, getUserEmployee, getApplicantEmail);
      this.view.setObjects(this.objects);
    } catch (error) {
      console.error("Error:", error);
      this.view.showError(error);
    }
  }

  async handleSubmit(formData) {
    const collection = this.view.getCollectionName();
    const acl = this.view.getAcl();
    let sendDetails = {};
    if (formData.id !== "") {
      const { password, ...formDataWithoutId } = formData;
      sendDetails = { ...formDataWithoutId };
    } else {
      const { id, ...formDataWithoutId } = formData;
      sendDetails = { ...formDataWithoutId };
    }

    sendDetails.acl = acl;
    console.log("sendDetails", sendDetails);
    await this.upsertUseCase.execute(collection, sendDetails);
    this.view.setObjects(this.objects);
    this.view.closeModal();
    this.reset();
    this.getObjects();
  }

  async getUser(token) {
    const options = { session: token };

    try {
      const user = await getCurrentUserUseCase().execute(options);
      if (user && typeof user === "object") {
        this.user = user;
      } else {
        throw new Error("Invalid response structure");
      }
    } catch (error) {
      console.error("Error fetching user:", error);
      this.view.navigateTo("/expired");
    }
  }

  validatePassword(newPassword, confirmNewPassword) {
    console.log("newPassword", newPassword);
    console.log("confirmNewPassword", confirmNewPassword);
    if (newPassword !== confirmNewPassword) {
      return "Password must be the same.";
    }

    if (newPassword.length < 8 || newPassword.length > 16) {
      return "Password length must be 8-16 characters.";
    }

    const validation =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*?&])(?=.*\d)[A-Za-z\d@$!%*?&]+$/;

    if (!validation.test(newPassword)) {
      return "Password must contain at least one uppercase letter, one lowercase letter, one special character, and one number.";
    }

    return null;
  }

  onSubmitPassword(password) {
    dialog.close();
    const user = this.user;
    const { newPassword, confirmNewPassword } = password;

    const errorMessage = this.validatePassword(newPassword, confirmNewPassword);

    if (errorMessage) {
      this.view.showError(errorMessage);
      return;
    }

    user.password = newPassword;
    this.updateUser(user);
  }

  updateUser(user) {
    this.view.showProgress();
    delete user.isMaster;

    updateObjectUseCase()
      .execute("users", user)
      .then((user) => {
        this.view.hideProgress();
        this.user = user;
        this.view.showSuccess("Successfully saved!");
      })
      .catch((error) => {
        this.view.hideProgress();
        this.view.showError(error);
      });
  }

  handleUpdateApplicant(empDetails, formData) {
    empDetails.docs1 = formData.docs1;
    empDetails.docs2 = formData.docs2;
    empDetails.docs3 = formData.docs3;
    empDetails.docs4 = formData.docs4;
    empDetails.docs5 = formData.docs5;
    empDetails.onBoardRemarks = formData.onBoardRemarks;
    empDetails.recruiter = { id: empDetails?.recruiter?.id };
    empDetails.applicant = { id: empDetails?.applicant?.id };
    empDetails.coordinator = { id: empDetails?.coordinator?.id };
    empDetails.onBoardAttachment = Array.isArray(empDetails.onBoardAttachment)
      ? [
          ...empDetails.onBoardAttachment,
          ...(Array.isArray(formData.attachment) ? formData.attachment : []),
        ]
      : [...(Array.isArray(formData.attachment) ? formData.attachment : [])];

    console.log("send", empDetails);

    try {
      let response;
      if (empDetails.interviewCoordinator === "online") {
        response = this.upsertUseCase.execute("online_applicants", empDetails);
      } else if (empDetails.interviewCoordinator === "walkIn") {
        response = this.upsertUseCase.execute("walkIn_applicants", empDetails);
      } else {
        response = this.upsertUseCase.execute(
          "reprocess_applicants",
          empDetails,
        );
      }

      response
        .then((updatedApplicant) => {
          this.objects = this.objects.map((obj) =>
            obj.id === updatedApplicant.id ? updatedApplicant : obj,
          );

          this.view.setObjects(this.objects);
          dialog.close();
          this.view.setState({
            showDetails: true,
            applicantDetails: updatedApplicant,
          });
          this.view.successModal("Data Successfully updated.");
        })
        .catch((error) => {
          console.error("Error updating applicant:", error);
          this.view.showError(error);
        });
    } catch (error) {
      console.error("Error:", error);
      this.view.showError(error);
    }
  }
}

export default ApplicantBoardingListPresenter;
